import styled from 'styled-components'

export const Line = styled.hr`
  margin: 1vh 0px;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  width: 100%;
`
